import { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";

import logo from '../backgroundimage.jpg';

import { baseurladdress } from '../baseurl';
import axios from 'axios';
// import {saveTokenInLocalStorage, saveUserID, saveUsername,synclab} from '../authservice/authservice';
import {saveTokenInLocalStorage, saveUserID, saveUsername,synclab,saveStaffid, saveRoleid} from '../authservice/authservice';

function Login() {
    const [email, setEmail] = useState("");
    const [password, setpassword] = useState("");

    const [erroremail, seterroremail] = useState("");
    const [errorpassword, seterrorpassword] = useState("");
    const [Errors, setErrors] = useState("");
    const [hidden, sethidden] = useState(true);
    let navigate = useNavigate();


    useEffect(() => {
        if ('caches' in window) {
            caches.keys().then(function (names) {
                names.forEach(function (name) {
                    caches.delete(name);
                });
            });
        }
    }, [])


    const LoginButton = (e) => {
        e.preventDefault();
        if (email == "" && password == "") {
            setErrors("Please fill the required fields")
        }
        else if (email == "") {
            seterroremail("Please fill Username ")
            seterrorpassword("");
            setErrors("");
        }
        else if (password == "") {
            seterrorpassword("Please fill Password ")
            setErrors("");
            seterroremail("");
        }
        else {

            axios.post(baseurladdress + `login/` + email + "/" + password)
                .then(res => {
                    console.log("test", res);
                    console.log(res.data);
                    console.log(res.data.id);
                    if (res.data.status === 'success') {
                        localStorage.setItem("selectedMenu", 1);
                        localStorage.setItem("selectedMenu", 2);
                        saveTokenInLocalStorage(res.data.token);
                        saveUserID(res.data.id);
                        saveUsername(res.data.name);
                        saveRoleid(res.data.roleid);
                        synclab(res.data.sync);
                        saveStaffid(res.data.staffid);
                        navigate("/dashboard");
                        let path = `dashboard`;
                        navigate(path);
                    }
                    if (res.data.status === 'notfound') {
                        setErrors("Login failed. Check username/password")
                        seterroremail("");
                        seterrorpassword("");
                    }
                })
        }
    }


    const FunctionPassword = () => {
        var x = document.getElementById("user_pass");
        if (x.type === "password") {
            x.type = "text";
            sethidden(false);
        } else {
            x.type = "password";
            sethidden(true);
        }
    }
    return (
        <div className="unix-login" style={{ "background": "url(" + logo + ") no-repeat", "backgroundSize": "cover", "height": "100vh", "overflowX": "hidden" }} >
            <div className="container-fluid " >
                <div className="row justify-content-center">
                    <div className="col-md-3">
                        <div className="login-content">
                            <div className="login-form">
                                <h4 style={{ "fontFamily": "unset" }}>DDC HR ADMIN </h4>
                                <h6 className='text-danger' >{Errors}</h6>
                                <form onSubmit={LoginButton}>
                                    <div className="form-group">
                                        <label >Username </label>
                                        <input type="text" className="form-control" placeholder="Username" onChange={(e) => setEmail(e.target.value)} value={email} />
                                    </div>
                                    <h6 className='text-danger'>{erroremail}</h6>
                                    <label>Password</label>
                                    <div className="input-group mb-3">
                                        <input type="password" id="user_pass" className="form-control" placeholder="Password" onChange={(e) => setpassword(e.target.value)}
                                            value={password} />
                                        <div className="input-group-append">
                                            <div className="input-group-text"
                                                onClick={() => {
                                                    FunctionPassword()
                                                }}
                                            >
                                                <span
                                                    className="fa fa-eye text-info"
                                                    id="togglePassword"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <h6 className='text-danger'>{errorpassword}</h6>
                                    {/* <div className="checkbox">
                                        <label>
                                            <input type="checkbox" /> Remember Me
                                        </label>
                                        <label className="float-lg-right text-right">
                                            <a href="#">Forgotten Password?</a>
                                        </label>
                                    </div> */}
                                    <button type="submit" className="btn btn-primary btn-flat m-b-30 m-t-30" >Sign in</button>

                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Login;